import { render, staticRenderFns } from "./DbiTabsView.vue?vue&type=template&id=3544beaf&scoped=true&"
import script from "./DbiTabsView.ts?vue&type=script&lang=ts&"
export * from "./DbiTabsView.ts?vue&type=script&lang=ts&"
import style0 from "./DbiTabsView.vue?vue&type=style&index=0&id=3544beaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544beaf",
  null
  
)

export default component.exports